exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".isStu-img[data-v-2084738c]{width:24px;height:24px}.yxtbiz-nav-lang__name[data-v-2084738c]{display:inline-block;max-width:80px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}\n", ""]);

